import {loadYaml} from '@/script/common';

export interface ExhibitorInfo {
  name: string;
  twitterImage: string;
  twitterUrl: string;
  pageName: string;
  pageUrl: string;
}

export default class ExhibitorManager {
  // シングルトン
  public static get INSTANCE(): ExhibitorManager {
    if (!ExhibitorManager._INSTANCE) {
      ExhibitorManager._INSTANCE = new ExhibitorManager();
    }
    return ExhibitorManager._INSTANCE;
  }
  private static _INSTANCE: ExhibitorManager;

  public exhibitorList: ExhibitorInfo[] = [];

  // コンストラクタの隠蔽
  private constructor() {}

  public async init() {
    this.exhibitorList = await loadYaml<ExhibitorInfo[]>('config/exhibitor.yaml');
    this.exhibitorList.forEach((exhibitor) => {
      exhibitor.name = exhibitor.name.replace('（', '\n（');
      if (exhibitor.twitterImage && !exhibitor.twitterImage.startsWith('http')) {
        exhibitor.twitterImage = `${process.env.VUE_APP_IMAGE_BASE_URL}${exhibitor.twitterImage}`;
      }
    });
  }
}
